import React from 'react';
import NumberedPagination from '../NumberedPagination/NumberedPagination';
import TableBodySkeleton from '../TableLoading/TableBodySkeleton';
import TableFetchOverlay from '../TableLoading/TableFetchOverlay';
import { getLocale, t } from '../../utils/i18n';

/**
 * Table card with stable layout: skeleton on first load, overlay on refetch, numbered pagination.
 */
export default function PaginatedTableCard({
  isPending = false,
  isFetching = false,
  isEmpty = false,
  skeletonRows = 10,
  skeletonCellWidths = [],
  colSpan = 1,
  minHeight = 'min-h-[28.5rem]',
  containerStyle,
  tableClassName = 'w-full',
  loadingLabel,
  emptyLabel,
  page,
  totalPages,
  currentPage,
  onPageChange,
  prevLabel,
  nextLabel,
  summary,
  pageSize,
  pageSizeOptions,
  onPageSizeChange,
  pageSizeLabel,
  header,
  children,
  error,
  dataUpdatedAt,
}) {
  const showOverlay = isFetching && !isPending;
  const dimRows = showOverlay;

  return (
    <div className="bg-dark-card border border-dark-border rounded-lg overflow-hidden">
      {error && <p role="alert" className="admin-notice admin-notice-error m-3">{t('adminUi.emptyFailure')}{dataUpdatedAt ? ` · ${t('adminUi.previousData')}` : ''}</p>}
      {dataUpdatedAt > 0 && <p className="px-4 pt-3 text-xs text-dark-text-secondary">{t('adminUi.dataUpdated')}: {new Date(dataUpdatedAt).toLocaleString(getLocale())}</p>}
      <div className={`relative overflow-x-auto ${minHeight}`} style={containerStyle}>
        <table className={tableClassName}>
          <thead>{header}</thead>
          <tbody className={dimRows ? '[&_tr]:opacity-60' : undefined}>
            {isPending ? (
              <TableBodySkeleton rows={skeletonRows} cellWidths={skeletonCellWidths} />
            ) : error && isEmpty ? (
              <tr><td colSpan={colSpan} className="py-16 text-center text-dark-text-secondary">{t('adminUi.emptyFailure')}</td></tr>
            ) : isEmpty ? (
              <tr>
                <td colSpan={colSpan} className="py-16 text-center text-dark-text-secondary">
                  {emptyLabel}
                </td>
              </tr>
            ) : (
              children
            )}
          </tbody>
        </table>
        <TableFetchOverlay show={showOverlay} label={loadingLabel} />
      </div>
      <NumberedPagination
        page={page}
        totalPages={totalPages}
        onPageChange={onPageChange}
        prevLabel={prevLabel}
        nextLabel={nextLabel}
        summary={summary}
        pageSize={pageSize}
        pageSizeOptions={pageSizeOptions}
        onPageSizeChange={onPageSizeChange}
        pageSizeLabel={pageSizeLabel}
      />
    </div>
  );
}
